import Vue from "vue";
import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import SubscriptionCSP from "../../../models/csp/SubscriptionCSP";
import subscriptionService from "../../../services/csp/subscriptionService";
import { RootState } from "../../index";

const namespaced = true;

interface SubscriptionState {
  subscriptions: SubscriptionCSP[];
}

const state: SubscriptionState = {
  subscriptions: []
};

const mutations: MutationTree<SubscriptionState> = {
  setSubscriptions(state, subscriptions: []) {
    state.subscriptions = subscriptions;
  },
  addSubscription(state, subscription: SubscriptionCSP) {
    const index = state.subscriptions.findIndex(
      s => subscription.getId == s.getId
    );
    if (index >= 0) state.subscriptions[index] = subscription;
    else state.subscriptions.push(subscription);
  },
  setSubscriptionAvailabilities(state, { subscriptionId, subscriptionTerms }) {
    const index = state.subscriptions.findIndex(s => subscriptionId == s.getId);
    if (index >= 0) state.subscriptions[index].setTerms = subscriptionTerms;
  },
  addSubscriptionsByCustomerId(state, subscriptions: SubscriptionCSP[]) {
    state.subscriptions.push(...subscriptions);
  }
};

const getters: GetterTree<SubscriptionState, RootState> = {
  getSubscriptionsCSP:
    state =>
    (customerId: string): SubscriptionCSP[] => {
      return state.subscriptions.filter(
        subscription => customerId == subscription.getCustomerId
      );
    },
  getAzurePlanSubscriptionsCSP:
    state =>
    (customerId: string): SubscriptionCSP[] => {
      return state.subscriptions.filter(
        sub =>
          sub.getOfferName == "Azure plan" && sub.getCustomerId == customerId
      );
    },
  getNonAzurePlanSubscriptionsCSP:
    state =>
    (customerId: string): SubscriptionCSP[] => {
      return state.subscriptions.filter(
        sub =>
          sub.getOfferName != "Azure plan" && sub.getCustomerId == customerId
      );
    },
  getSubscriptionCSPById:
    state =>
    (subscriptionId: string): SubscriptionCSP => {
      return state.subscriptions.find(
        subscription => subscriptionId == subscription.getId
      );
    }
};

const actions: ActionTree<SubscriptionState, RootState> = {
  async loadAllSubscriptionCSPIdsByCustomerId({ commit }, customerId) {
    const subscriptionIds: SubscriptionCSP[] =
      await subscriptionService.methods.getAllSubscriptionIdsByTenantId(
        customerId
      );
    const newSubscriptions = subscriptionIds.filter(
      sub =>
        !state.subscriptions.some(
          existentSub => existentSub.getId === sub.getId
        )
    );
    if (newSubscriptions.length > 0) {
      commit("addSubscriptionsByCustomerId", newSubscriptions);
    }
  },
  async loadSubscriptionCSPByTenantIdAndSubscriptionId(
    { commit },
    { tenantId, subscriptionId }
  ) {
    const subscription =
      await subscriptionService.methods.getSubscriptionByTenantIdAndSubscriptionId(
        tenantId,
        subscriptionId
      );
    commit("addSubscription", subscription);
  },
  async loadSubscriptionCSPAvailabilities(
    { commit },
    { subscriptionId, endpoint }
  ) {
    try {
      const subscriptionTerms =
        await subscriptionService.methods.getAvailabilities(endpoint);
      commit("setSubscriptionAvailabilities", {
        subscriptionId,
        subscriptionTerms
      });
    } catch {
      Vue.$log.error(
        "Availabilities not found for subscription",
        subscriptionId
      );
    }
  },
  async putSubscriptionCSP({}, { tenantId, subscriptionId, body }) {
    await subscriptionService.methods.putSubscription(
      tenantId,
      subscriptionId,
      body
    );
  }
};

export const subscriptionModuleCSP: Module<SubscriptionState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
